import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunecabservice() {



const cardData = {
  keyword: "Mumbai to Pune Cab Service",
  heading: "Lotus Cab: Mumbai to Pune Cab Service",

  headingDescription:
    "Lotus Cab offers safe, comfortable, and affordable Mumbai to Pune cab services for business travelers, families, tourists, and corporate clients. Whether you need a one-way drop, round-trip taxi, or same-day return package, we provide flexible travel options with transparent per-kilometer pricing. Our experienced chauffeurs ensure smooth driving via the Mumbai–Pune Expressway, maintaining safety and punctuality. The fleet includes AC sedans, spacious SUVs, luxury cars, and premium MPVs suitable for every budget and group size. Vehicles are regularly serviced, sanitized, and equipped for long-distance comfort. With 24/7 booking support and reliable pickup across Mumbai, Lotus Cab guarantees a stress-free highway travel experience to Pune.",

  top: "Top Places to Visit in Pune After Reaching from Mumbai",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most famous historical landmarks reflecting Maratha heritage. Located centrally, it attracts history enthusiasts and tourists year-round. The massive fort walls and architecture create a memorable sightseeing experience. Evening light-and-sound shows enhance the visit. Ideal for family and group exploration after long-distance travel. Lotus Cab provides convenient drop and waiting options."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a peaceful monument linked to India’s freedom movement. Beautiful gardens and museum exhibits attract cultural visitors. The calm atmosphere makes it ideal for relaxed sightseeing. Suitable for families and educational tours. AC cab service ensures comfortable city travel. Flexible drop timing provided by Lotus Cab."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort offers panoramic views and is a popular weekend getaway near Pune. The scenic drive and historical significance attract tourists. Ideal for short hill visits after city arrival. SUV cabs are recommended for this route. Drivers ensure safe navigation on hill roads. Lotus Cab provides round-trip packages."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "Dagdusheth Ganpati Temple is one of Pune’s most visited religious sites. Devotees visit daily for blessings and peaceful darshan. The temple is centrally located and easily accessible. Perfect spiritual stop after highway travel. Clean and punctual cab service ensures smooth visits. Lotus Cab provides comfortable city transfers."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam is a scenic picnic destination near Pune. Popular for evening relaxation and photography. Families enjoy the peaceful water views. Ideal for short detours after arrival. AC cab travel enhances comfort. Lotus Cab offers flexible waiting packages."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a beautiful hill city located near Pune. Many travelers plan weekend trips here. The scenic drive and lakeside views make it attractive. Comfortable SUV or sedan options available. Lotus Cab provides customized round-trip services."
    }
  ],

  services: [
    {
      name: "Mumbai to Pune Cabs",
      description:
        "Lotus Cab provides reliable Mumbai to Pune cab service with flexible pickup locations across Mumbai city. Our drivers are experienced in expressway travel and ensure safe long-distance journeys. AC vehicles are clean and well-maintained for maximum comfort. Ideal for business, family, and weekend travel. Transparent per-km pricing eliminates hidden charges. Available 24/7 for convenient booking."
    },
    {
      name: "Mumbai to Pune One Way Cab",
      description:
        "Affordable one-way cab option where you pay only for single-side distance. Perfect for airport drops, business travel, and relocations. Professional drivers ensure punctual pickup. AC comfort guaranteed for long-distance ride. Transparent billing shared before confirmation. Smooth and safe expressway travel."
    },
    {
      name: "Mumbai to Pune Round Trip Taxi",
      description:
        "Round-trip taxi service allows flexible return scheduling. Ideal for same-day business trips or weekend outings. Comfortable AC vehicles available in sedan and SUV categories. Transparent pricing with no hidden charges. Experienced drivers ensure safe driving. Convenient booking support available."
    },
    {
      name: "Affordable Cab Mumbai to Pune",
      description:
        "Budget-friendly travel option without compromising safety and comfort. Fuel-efficient sedans and compact SUVs available. Suitable for small families and solo travelers. AC and clean interiors maintained regularly. Honest per-km pricing structure. Reliable highway performance."
    },
    {
      name: "Luxury Cab Mumbai to Pune",
      description:
        "Premium luxury vehicles available for executive and VIP travelers. High-end interiors provide superior comfort. Chauffeur-driven professional service ensured. Ideal for corporate guests and special occasions. Smooth and quiet cabin experience. Flexible travel packages available."
    },
    {
      name: "SUV Cab Mumbai to Pune",
      description:
        "Spacious SUV options suitable for families and group travel. Extra luggage capacity for comfortable long-distance travel. Stable highway performance ensures safety. AC interiors maintained clean and sanitized. Professional drivers available. Flexible one-way and round-trip booking."
    }
  ],

  tableData: [
    ["Mumbai to Pune Cabs", "Mumbai to Pune One Way Cab"],
    ["Mumbai to Pune Round Trip Taxi", "Affordable Cab Mumbai to Pune"],
    ["Luxury Cab Mumbai to Pune", "SUV Cab Mumbai to Pune"],
    ["Sedan Taxi Mumbai to Pune", "Family Trip Cab Mumbai to Pune"],
    ["Corporate Cab Mumbai to Pune", "Weekend Trip Taxi Mumbai to Pune"],
    ["AC Cab Mumbai to Pune", "Online Booking Mumbai to Pune"],
    ["Best Outstation Cab Mumbai to Pune", "Per Km Rate Mumbai to Pune"],
    ["Same Day Return Cab Mumbai to Pune", "Group Tour Cab Mumbai to Pune"],
    ["Picnic Cab Mumbai to Pune", "Outstation Taxi Service Mumbai to Pune"],
    ["Chauffeur Driven Cab Mumbai to Pune", "Budget Luxury Cab Mumbai to Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Safe Expressway Travel",
      WhyChoosedescription:
        "Our drivers are trained for Mumbai–Pune Expressway driving. Vehicles are regularly serviced and inspected. Highway safety rules strictly followed. Smooth and stable journey ensured. Professional long-distance experience."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear fare breakdown shared before booking. No hidden toll surprises. Flexible pricing models available. Affordable across vehicle types."
    },
    {
      WhyChooseheading: "24/7 Service Availability",
      WhyChoosedescription:
        "Round-the-clock booking and travel support. Early morning and late-night pickups available. Quick confirmation process."
    },
    {
      WhyChooseheading: "Wide Fleet Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury, and group travel vehicles available. Suitable for solo and large groups. Clean and AC vehicles."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Background-verified and experienced drivers. Courteous behavior and punctuality maintained."
    },
    {
      WhyChooseheading: "Corporate & Family Friendly",
      WhyChoosedescription:
        "Suitable packages for corporate meetings and family trips. Invoice support available."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription:
        "One-way, round-trip, and same-day return packages. Customized travel planning available."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription:
        "Dedicated support team assists during booking and travel duration."
    }
  ]
};

const faqData = [
  { question: "Do you provide one-way Mumbai to Pune cab?", answer: "Yes, affordable one-way drop service available with transparent per-km pricing and safe expressway travel." },
  { question: "Is round-trip booking available?", answer: "Yes, flexible round-trip packages with return scheduling options are available." },
  { question: "Are SUVs available for family travel?", answer: "Yes, spacious SUV options available for group and family trips." },
  { question: "Is service available 24/7?", answer: "Yes, we operate 24/7 including late-night travel." },
  { question: "Is AC included?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Are toll charges included?", answer: "Toll charges are clearly mentioned before booking confirmation." },
  { question: "Do you offer luxury vehicles?", answer: "Yes, premium and luxury car options available." },
  { question: "Is online booking available?", answer: "Yes, instant booking confirmation available online." },
  { question: "Is corporate billing supported?", answer: "Yes, invoice billing support provided for corporate clients." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return packages available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "Booked one-way cab from Mumbai to Pune. Smooth journey and professional driver. Clean AC vehicle and transparent pricing.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "Used service for business travel. Very punctual and comfortable highway ride. Highly recommended.",
    rating: 5
  },
  {
    id: 3,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Family trip from Mumbai to Pune was comfortable. SUV was spacious and driver was helpful.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Raj Patel",
    feedback:
      "Excellent service and no hidden charges. Reliable long-distance cab option.",
    rating: 5
  }
];




























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Cab Service",
  "image": "https://lotuscab.com/assets/images/mumbai-to-pune-cab-service.jpg", 
  "description": "Lotus Cab offers professional Mumbai to Pune cab services with AC, sedan, SUV, and luxury vehicles. Ideal for one-way trips, round trips, family travel, corporate transfers, weekend getaways, group tours, picnic trips, and same-day returns. Book online for chauffeur-driven cabs at affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mumbai-to-pune-cab-service"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Mumbai to Pune Cab Service | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune cabs with Lotus Cab. AC, sedan, SUV, luxury cabs for one-way, round trips, family, corporate, weekend, group & picnic travel. Online booking available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Cabs, Mumbai to Pune One Way Cab, Mumbai to Pune Round Trip Taxi, Affordable Cab Mumbai to Pune, Luxury Cab Mumbai to Pune, SUV Cab Mumbai to Pune, Sedan Taxi Mumbai to Pune, Family Trip Cab Mumbai to Pune, Corporate Cab Mumbai to Pune, Weekend Trip Taxi Mumbai to Pune, AC Cab Mumbai to Pune, Online Booking Mumbai to Pune, Best Outstation Cab Mumbai to Pune, Per Km Rate Mumbai to Pune, Same Day Return Cab Mumbai to Pune, Group Tour Cab Mumbai to Pune, Picnic Cab Mumbai to Pune, Outstation Taxi Service Mumbai to Pune, Chauffeur Driven Cab Mumbai to Pune, Budget Luxury Cab Mumbai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunecabservice;